import type { Event } from '@patsnap/tahiti-core/common/event';
import type { AIDisclosureResultState, DisclosureResult } from '../types';
import { type AIDisclosureParagraphEditType, AIDisclosureParagraphType, StreamStatus } from '../enums';

export const AIDisclosureResultService = Symbol('AIDisclosureResultService');

export interface AIDisclosureResultService {
    getModelData: () => AIDisclosureResultState;
    readonly onStatesChange: Event<AIDisclosureResultState>;
    generateContent: (params: {
        contentType: AIDisclosureParagraphEditType,
        text?: string
    }, callback: (status: StreamStatus, content?: string) => void) => void;
    generateResult: (isInit?: boolean) => void;
    stopGenerate: () => void;
    updateTitle: (newTitle: string) => void;
    updateDisclosureResult: (paragraphType: AIDisclosureParagraphType, content: string, isAddition?: boolean) => void;
    updateSetting: (settings: AIDisclosureResultState['settings'], init?: boolean) => Promise<void>;
    toggleParagraphVisibleStatus: (type: AIDisclosureParagraphType) => void;
    initModel: (modelData: Partial<AIDisclosureResultState>) => void;
    regenerateContent: () => void;
}
